import { ref, computed, triggerRef } from 'vue';
import type { DocumentRevision } from '@/entities/Document';

export function useQualityRecordSelection() {
  const selectedRecordIds = ref<Set<number>>(new Set());

  const isRecordSelected = (id: number) => {
    return selectedRecordIds.value.has(id);
  };

  const toggleRecordSelection = (id: number) => {
    if (selectedRecordIds.value.has(id)) {
      selectedRecordIds.value.delete(id);
    } else {
      selectedRecordIds.value.add(id);
    }
    triggerRef(selectedRecordIds);
  };

  const selectAllRecords = (records: DocumentRevision[]) => {
    records.forEach((record) => selectedRecordIds.value.add(record.id));
    triggerRef(selectedRecordIds);
  };

  const deselectAllRecords = () => {
    selectedRecordIds.value.clear();
    triggerRef(selectedRecordIds);
  };

  const toggleAllRecords = (records: DocumentRevision[]) => {
    const allSelected = records.every((record) => selectedRecordIds.value.has(record.id));
    if (allSelected) {
      deselectAllRecords();
    } else {
      selectAllRecords(records);
    }
  };

  const selectedCount = computed(() => selectedRecordIds.value.size);

  const selectedRecords = computed(() => Array.from(selectedRecordIds.value));

  const hasSelectedRecords = computed(() => selectedRecordIds.value.size > 0);

  return {
    selectedRecordIds: selectedRecordIds.value,
    selectedCount,
    selectedRecords,
    hasSelectedRecords,
    isRecordSelected,
    toggleRecordSelection,
    selectAllRecords,
    deselectAllRecords,
    toggleAllRecords,
  };
}
